import { render, staticRenderFns } from "./UploadQaAssetsCommand.vue?vue&type=template&id=22555563&scoped=true&"
import script from "./UploadQaAssetsCommand.vue?vue&type=script&lang=ts&"
export * from "./UploadQaAssetsCommand.vue?vue&type=script&lang=ts&"
import style0 from "./UploadQaAssetsCommand.vue?vue&type=style&index=0&id=22555563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22555563",
  null
  
)

export default component.exports